<template>
    <div>
        <div v-if="fetching">
            <loading size="small"></loading>
        </div>

        <div v-else class="mb-16">
            <div v-if="items && items.length">
                <select-dropdown
                    v-model="filter.offices"
                    reference="id"
                    label="name"
                    multiple
                    searchable
                    remove-icon
                    can-select-all
                    :loading="fetching"
                    :autoTranslate="false"
                    :limited-items-count="5"
                    :truncate="true"
                    :options="items"
                    :placeholder="$t('form.dropdown.placeholder').toString()"
                />
            </div>
            <div v-else>
                <banner
                    :title="$t('applications.no_offices_title')"
                    :description="$t('applications.no_offices_found')"
                    link="interims"
                    :link-text="$t('applications.no_offices_confirmbutton')"
                    internal-link
                    class="-mt-2"
                    inline
                    :one-line="false"
                />
            </div>
        </div>
    </div>
</template>


<script>
import Loading from '../ui/Loading.vue';
import Toggle from '../forms/Toggle.vue';
import * as applications from '../../services/ApplicationService';
import Interim from '../../models/Interim';
import {normalizeJson} from "../../../shared/helpers";
import SelectDropdown from "../forms/SelectDropdown.vue";
import Banner from "../ui/Banner.vue";
import {useRepo} from "pinia-orm";

export default {
    components: {
        Banner,
        Loading,
        Toggle,
        SelectDropdown
    },
    props: {
        filter: Object,
    },
    data: function () {
        return {
            fetching: true,
        };
    },
    computed: {
        items() {
            return useRepo(Interim).orderBy('name').get();
        },
    },
    methods: {
        fetch() {
            this.fetching = true;

            applications.offices()
                .then(result => {
                    useRepo(Interim).save(result.data);
                }).then(() => {
                    this.fetching = false;
                }
            );
        },
    },
    mounted() {
        this.fetch();
    },
};
</script>
